import { render, staticRenderFns } from "./EditMenuButton.vue?vue&type=template&id=10ea2afa&scoped=true&"
import script from "./EditMenuButton.vue?vue&type=script&lang=js&"
export * from "./EditMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./EditMenuButton.vue?vue&type=style&index=0&id=10ea2afa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ea2afa",
  null
  
)

export default component.exports